
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigation from './navigation';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import store from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const App = () => {
  let persistor = persistStore(store);
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div className="App">
            <Navigation />
            <ToastContainer />
          </div>
        </PersistGate>
      </Provider>
    </>
  );
};
export default App;
